<div class="placetopay-result" *ngIf="request">

  <!-- Generic Error -->
  <div *ngIf="errorHeader" class="note-confirm rejected">
    <p><i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp;<strong>{{ errorHeader }}</strong></p>
    <p *ngIf="errorText">{{ errorText }}</p>
    <p *ngIf="errorFoot" class="small-note">{{ errorFoot }}</p>
  </div>

  <!-- Payment Details Table -->
  <table class="table" style="margin-bottom: 20px; margin-top: 15px;">
    <tbody>
      <tr>
        <td style="width: 50%;"><strong>Reference:</strong><br>{{ request.reference }}</td>
        <td><strong>Transaction ID:</strong><br>{{ request.requestId }}</td>
      </tr>
      <tr>
        <td><strong>Date:</strong> {{ request.status?.date | date:'MMM d, yyyy' }}</td>
        <td><strong>Status:</strong>
          <span class="status-badge" [ngClass]="{
            'badge-success': request.status?.status === 'APPROVED',
            'badge-warning': request.status?.status === 'PENDING',
            'badge-danger': request.status?.status === 'REJECTED' || request.status?.status === 'FAILED'
          }">{{ request.status?.status }}</span>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Toggle for additional message -->
  <div *ngIf="request.status?.message && request.status?.status !== 'APPROVED'" class="message-toggle">
    <a href="javascript:void(0)" (click)="toggleMessage()">
      <i class="fa" [ngClass]="showMessage ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      {{ showMessage ? 'Hide details' : 'Show details' }}
    </a>
    <p *ngIf="showMessage" class="status-message">{{ request.status?.message }}</p>
  </div>
</div>
